/* SR-006: ProFlex PDP gallery shim
   Forces gallery to switch to the correct variant when arriving via ?variant=...
   Native Shopify selects the variant server-side, but the gallery JS only
   updates on a click event — this fakes the click for non-default variants.

   Reads variant ID -> size mapping from window.SR006_VARIANT_MAP, which is
   injected by theme.liquid only on the proflex product page (portable across
   NA/AU/EU since each store has its own variant IDs).

   Ported from Intelligems SR-006 Custom JS. */

(function() {
  'use strict';

  if (!window.SR006_VARIANT_MAP) return;

  var params = new URLSearchParams(window.location.search);
  var variantId = params.get('variant');
  if (!variantId) return;

  var sizeName = window.SR006_VARIANT_MAP[variantId];
  if (!sizeName || sizeName === 'Narrow') return;

  document.documentElement.classList.add('sr-pdp-gallery-hidden');

  function reveal() {
    document.documentElement.classList.remove('sr-pdp-gallery-hidden');
    document.documentElement.classList.add('sr-pdp-gallery-visible');
    setTimeout(function() {
      document.documentElement.classList.remove('sr-pdp-gallery-visible');
    }, 200);
  }

  function doSwitch() {
    var targetInput = document.querySelector('.l-product-vp__input[value="' + sizeName + '"]');
    var targetLabel = targetInput ? document.querySelector('label[for="' + targetInput.id + '"]') : null;
    if (!targetInput || !targetLabel) return false;

    var checkedInput = document.querySelector('.l-product-vp__input:checked');
    if (checkedInput) {
      checkedInput.checked = false;
      checkedInput.removeAttribute('checked');
    }

    targetInput.checked = true;
    targetInput.setAttribute('checked', '');
    targetInput.dispatchEvent(new Event('input', { bubbles: true }));
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));

    var events = ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'];
    for (var i = 0; i < events.length; i++) {
      targetLabel.dispatchEvent(new MouseEvent(events[i], {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    }

    setTimeout(reveal, 250);
    return true;
  }

  if (!doSwitch()) {
    var pdpObserver = new MutationObserver(function(mutations, obs) {
      if (doSwitch()) { obs.disconnect(); }
    });
    pdpObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { pdpObserver.disconnect(); reveal(); }, 2000);
  }

})();
